import parseHTML from "html-react-parser";
import sanitizeHTML from "sanitize-html";

import { ALLOWED_POST_CONTENT_HTML_TAGS } from "@hubcapp/constants";

export const parsePostContent = (content: string) =>
  parseHTML(
    sanitizeHTML(content, {
      allowedTags: ALLOWED_POST_CONTENT_HTML_TAGS,
    }),
  );
